<template>
  <zm-form class="phone-number__search" :class="{
    'port-number__search--error': vanitySuffixErrorMsg
  }" :disabled="loading">
    <zm-form-item class="phone-number__search--prefix">
      <zm-select
        data-testid="checkout-select-199"
        size="large"
        v-model="tollFreeNumberState.searchForm.selectTfPrefix"
        :popper-append-to-body="true"
        @change="changeTfPrefix"
        label="Toll-free prefix "
        :placeholder="$t('billing.pbx.tollFree.prefix_placeholder')"
      >
        <zm-option
          v-for="p in supportTollFreePrefixList"
          data-testid="checkout-option-200"
          :key="p"
          :value="p"
          :label="p"
        />
      </zm-select>
    </zm-form-item>
    <p>{{ $t('billing.common.or') }}</p>
    <zm-form-item :error="vanitySuffixErrorMsg">
      <zm-input
        data-testid="checkout-input-201"
        :type="!$context.is.desktop ? 'search' : 'text'"
        size="large"
        :maxlength="7"
        :placeholder="$t('billing.pbx.tollFree.vanity_placeholder')"
        v-model="tollFreeNumberState.searchForm.vanitySuffix"
        class="phone-number__search--area-code"
        @keyup.enter.native="searchNumbers"
        @input="changeVanity"
      >
        <i slot="prefix" class="zm-input__icon zm-icon-search"></i>
      </zm-input>
    </zm-form-item>
    <zm-button
      data-testid="checkout-button-202"
      type="link"
      v-if="$context.is.desktop || $context.is.tablet"
      class="phone-number__search--btn"
      :disabled="searchDisabled"
      @click="searchNumbers"
    >
      {{ $t('billing.common.search') }}
    </zm-button>
  </zm-form>
</template>

<script>
import { supportTollFreePrefixList } from '@/plans/ZOOM_PHONE/helper/constants';
import { checkVanitySuffixLength } from '@/plans/ZOOM_PHONE/helper/validate';
import phoneNumberApiMixin from '@/plans/ZOOM_PHONE/mixin/phone-number-api';
import { getDefaultTollFreeSearchForm, tollFreeNumberStore } from '../store';
import { isEmptyVal } from '@/utils';
import computedMixin from '@/plans/ZOOM_PHONE/mixin/computed';
import phoneNumberPropsMixin from '@/plans/ZOOM_PHONE/mixin/phone-number-props';
import _ from 'lodash';
import { getCurrentTrackingPlanName } from '@/plans/ZOOM_PHONE/helper/utils';

export default {
  name: 'TollFreeSearch',
  mixins: [phoneNumberApiMixin, computedMixin, phoneNumberPropsMixin],
  data() {
    return {
      supportTollFreePrefixList: supportTollFreePrefixList,
      vanitySuffixErrorMsg: '',
      tollFreeNumberState: tollFreeNumberStore.state,
      lastSearchForm: getDefaultTollFreeSearchForm(),
    };
  },
  computed: {
    trackingPlanName() {
      return getCurrentTrackingPlanName();
    },
    searchDisabled() {
      return isEmptyVal(this.tollFreeNumberState?.searchForm?.vanitySuffix) || !isEmptyVal(this.vanitySuffixErrorMsg);
    },
  },
  methods: {
    changeTfPrefix() {
      this.tollFreeNumberState.searchForm.vanitySuffix = '';
      this.search();
    },
    changeVanity(search) {
      this.vanitySuffixErrorMsg = checkVanitySuffixLength(search);
    },
    searchNumbers() {
      if (this.searchDisabled) return;

      const existUnReadNumber = this.checkExistUnreadPhoneNumbers();
      const searchForm = this.tollFreeNumberState.searchForm;
      const lastSearchForm = this.lastSearchForm;

      // exist unread phoneNumbers with current call api result
      if (_.isBoolean(existUnReadNumber) && existUnReadNumber && _.isEqual(searchForm, lastSearchForm)) {
        return this.gotoNextPage();
      }

      this.search();
    },
    async search() {
      const searchForm = this.tollFreeNumberState.searchForm;
      const list = await this.searchTollFreeNumbers(searchForm);
      this.tollFreeNumberState.phoneNumberList = list;
      this.tollFreeNumberState.searchTimes++;
      this.lastSearchForm = _.cloneDeep(searchForm);
      this.$tracking.buyInteraction(`${this.trackingPlanName} numbers`, `${this.callingPlanName} - pick your numbers - toll-free - search`);
    },
    toggleLoading(value = false) {
      this.loading = value;
      this.tollFreeNumberState.loading = value;
      this.$emit('toggleLoading', value);
    },
    resetForm() {
      if (this.vanitySuffixErrorMsg) {
        this.vanitySuffixErrorMsg = '';
        this.tollFreeNumberState.searchForm = getDefaultTollFreeSearchForm();
      }
    },
  },
};
</script>

<style lang="scss">
@import "./style/number-search.scss";

.port-number {
  &__search {
    &--error {
      margin-bottom: 36px;
    }
  }
}
</style>
